module.exports = __webpack_public_path__ + "img/sentinelaoclogo.a29aa870.png";